var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToyotaVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3707 20.8861C12.2101 20.8882 0.529663 20.939 0.529663 20.939L0.534852 15.7787C0.448005 14.6792 1.48935 13.6646 1.48935 13.6646L4.89907 11.1067C7.25542 9.34383 10.2364 7.16691 11.7051 6.09716C12.2969 5.66592 12.9863 5.38818 13.7113 5.29013C18.8613 4.59126 23.9189 3.99971 29.1522 4.40609C30.125 4.48174 31.0928 4.63495 32.0389 4.87474C33.6021 5.27074 35.1556 5.91964 36.4468 6.89954C37.8609 7.97284 38.4732 9.46126 39.088 11.0171C39.345 11.6671 39.5118 12.3477 39.5826 13.0428C39.8278 15.4546 40.0927 20.0348 38.3113 20.5308L30.8378 20.8052L19.7161 20.8459L12.3707 20.8861Z",
    fill: "#E50C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8271 11.4202L27.5295 11.4202L25.4294 20.7548H24.5295L26.8271 11.4202Z",
    fill: "#B90315"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.709 11.6874L39.1096 12L38.6956 10.5208C38.1004 9.01446 37.3759 7.57511 36.0067 6.53596C34.7566 5.58725 33.1615 5.23885 31.648 4.85545C30.7321 4.6233 29.795 4.47496 28.8532 4.40172C28.8532 4.40172 27.7326 4.3216 27.1977 4.30627C26.6131 4.28934 25.5858 4.27295 25.5858 4.27295L19.709 11.6874Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26318 11.6874H15.8886L22.4416 4.43726C19.4717 4.58317 16.5254 4.95154 13.5469 5.35671C12.8459 5.45178 12.0311 5.84481 11.4589 6.26269C10.0387 7.3 4.89897 11.1067 4.89897 11.1067L4.26318 11.6874Z",
    fill: "#EDEDED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6053 4L19.1306 12L39.5295 12.2017",
    stroke: "#B90315",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52954 12H16.0702L23.2962 4",
    stroke: "#B90315",
    strokeWidth: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6498 18.5917H5.14449C4.65782 18.5917 4.26318 18.1973 4.26318 17.7104C4.26318 17.224 4.65782 16.8296 5.14449 16.8296H8.6498C9.13647 16.8296 9.53111 17.224 9.53111 17.7104C9.53111 18.1973 9.13647 18.5917 8.6498 18.5917Z",
    fill: "#B90315"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9178 14.4661H13.8128C14.2819 14.4661 14.4927 15.0539 14.1306 15.3521L12.0357 17.0767C11.5205 17.4809 10.7755 17.3909 10.3716 16.876L9.98548 16.3842C9.37454 15.6061 9.92872 14.4661 10.9178 14.4661ZM12.418 15.4656L10.9178 15.4661C10.7631 15.4661 10.6762 15.6447 10.772 15.7667L11.1583 16.2587C11.2214 16.3392 11.3378 16.3532 11.4092 16.2974L12.418 15.4656Z",
    fill: "#B90315"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7008 14.4661C10.9769 14.4661 11.2008 14.6899 11.2008 14.9661C11.2008 15.2115 11.0239 15.4157 10.7907 15.458L10.7008 15.4661H0.991089C0.714946 15.4661 0.491089 15.2422 0.491089 14.9661C0.491089 14.7206 0.667964 14.5165 0.901213 14.4741L0.991089 14.4661H10.7008Z",
    fill: "#B90315"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3707 20.8849C12.2101 20.8871 0.529663 20.939 0.529663 20.939L0.534852 15.6752C0.448005 14.5536 1.48935 13.5187 1.48935 13.5187L4.89907 10.9095C7.25542 9.11126 10.2364 6.8907 11.7051 5.7995C12.2969 5.35962 12.9863 5.0763 13.7113 4.97629C18.8613 4.2634 23.9189 3.66 29.1522 4.07453C30.125 4.15169 31.0928 4.30798 32.0389 4.55257C33.6021 4.95651 35.1556 5.61842 36.4468 6.61797C37.8609 7.71279 38.4732 9.23105 39.088 10.8181C39.345 11.4812 39.5119 12.1754 39.5826 12.8844C39.8278 15.3445 40.0927 20.0166 38.3113 20.5225L30.8378 20.8025L19.7161 20.844L12.3707 20.8849Z",
    stroke: "#B90315",
    strokeWidth: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9483 21.0778C19.9483 23.2359 18.1988 24.9857 16.0404 24.9857C13.8821 24.9857 12.1326 23.2359 12.1326 21.0778C12.1326 18.9195 13.8821 17.1697 16.0404 17.1697C18.1988 17.1697 19.9483 18.9195 19.9483 21.0778Z",
    fill: "#EDEDED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9483 21.0778C19.9483 23.2359 18.1988 24.9857 16.0404 24.9857C13.8821 24.9857 12.1326 23.2359 12.1326 21.0778C12.1326 18.9195 13.8821 17.1697 16.0404 17.1697C18.1988 17.1697 19.9483 18.9195 19.9483 21.0778",
    stroke: "#B90315",
    strokeWidth: 0.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4202 21.0778C38.4202 23.2359 36.6707 24.9857 34.5124 24.9857C32.354 24.9857 30.6045 23.2359 30.6045 21.0778C30.6045 18.9195 32.354 17.1697 34.5124 17.1697C36.6707 17.1697 38.4202 18.9195 38.4202 21.0778Z",
    fill: "#EDEDED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4202 21.0778C38.4202 23.2359 36.6707 24.9857 34.5124 24.9857C32.354 24.9857 30.6045 23.2359 30.6045 21.0778C30.6045 18.9195 32.354 17.1697 34.5124 17.1697C36.6707 17.1697 38.4202 18.9195 38.4202 21.0778",
    stroke: "#B90315",
    strokeWidth: 0.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.529541 20.9392C0.529541 23.0973 2.27932 24.8471 4.43767 24.8471C6.59575 24.8471 8.34526 23.0973 8.34526 20.9392H0.529541Z",
    fill: "#EDEDED",
    stroke: "#B90315",
    strokeWidth: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyotaVehicleIcon);
export default __webpack_public_path__ + "static/media/toyota-vehicle-icon.34b1252a.svg";
export { ForwardRef as ReactComponent };